/*jshint esversion: 8 */
import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { observer } from "mobx-react";
import { withStyles } from '@material-ui/core/styles';
import SelectionOfRoomTicketInfoManagement from './SelectionOfTicketInfoManagement';
import TableOfRoomTicketInfoManagement from './TableOfTicketInfoManagement';
import Typography from '@material-ui/core/Typography';
import store from "../../../components/stores/Store";

const styles = {
  root: {
    '& .MuiTextField-root': {
      margin: '10px',
      width: '25ch',
    },
  },
};

class RoomTicketInfoManagementInner extends Component {
  constructor() {
    super();
    this.state = {
      login: true,
    };
  }

  async componentDidMount() {
    document.title = "房票信息管理";
  }

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <Typography variant="h5" gutterBottom>
          房票信息管理
        </Typography>
        <SelectionOfRoomTicketInfoManagement />
        <TableOfRoomTicketInfoManagement />
      </div>
    );
  }
}

const RoomTicketInfoManagement = observer(RoomTicketInfoManagementInner);

RoomTicketInfoManagement.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(RoomTicketInfoManagement);

// for mobile template
// https://material-ui.com/store/previews/devias-kit/
// https://material-ui.com/store/previews/paperbase/
// https://demos.creative-tim.com/material-kit-react/#/